import { Hexagon } from "../common/Hexagon";

const formatNumber = (value) => (value === null || value === undefined ? "—" : Number(value).toLocaleString());

/**
 * Franja de 4 KPIs de Usuarios (README pantalla 4): registrados, con red
 * activa, sin autenticar, nuevos este mes.
 *
 * Sólo `total` viene garantizado por `/users/all/paginate` (ya se usa para
 * la paginación). Los otros tres no los expone ningún hook hoy — se leen
 * de forma defensiva por si el backend ya los manda sin que la UI los usara
 * todavía; si no vienen, se muestra "—" en vez de inventar un 0 (mismo
 * criterio que `growth: null` en el dashboard).
 */
const UserStatsCards = ({
  total = 0,
  activeNetwork = null,
  unconfirmed = null,
  newThisMonth = null,
}) => {
  const cards = [
    { title: "Usuarios registrados", value: formatNumber(total), icon: "ri-team-line", color: "#4B36F0" },
    { title: "Con red activa", value: formatNumber(activeNetwork), icon: "ri-user-follow-line", color: "#0F9A5A" },
    { title: "Sin autenticar", value: formatNumber(unconfirmed), icon: "ri-user-unfollow-line", color: "#D97706" },
    { title: "Nuevos este mes", value: formatNumber(newThisMonth), icon: "ri-user-add-line", color: "#7C3AED" },
  ];

  return (
    <div className="ui-grid-kpis">
      {cards.map((card) => (
        <div
          key={card.title}
          className="d-flex align-items-center gap-3"
          style={{ background: "#fff", border: "1px solid #E8EAF2", borderRadius: 14, padding: "16px 20px" }}
        >
          <Hexagon size={46} color={card.color} icon={card.icon} />
          <div className="text-truncate">
            <div style={{ color: "#5A6187", fontSize: 12.5, fontWeight: 600 }}>{card.title}</div>
            <div style={{ fontSize: 24, fontWeight: 800, color: card.color, letterSpacing: "-0.025em", marginTop: 1 }}>
              {card.value}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default UserStatsCards;
